module.exports = __webpack_public_path__ + "img/EMS_user_manual_timeline7.2da99641.png";